module.exports = __webpack_public_path__ + "static/media/DSC_0254.fae238cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0254.jpg
// module id = 655
// module chunks = 0